import router from './router';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import { hasLogin } from '@/utils/auth'; // 验权
import store from './store';
import Lockr from 'lockr';

var whiteList = ['/login', '/operateWatchTableShow', '/operateWatchTableShowBJ', '/operateWatchTableShowCD']; // 不重定向白名单

//全局 每次切换路径的时候都先进行登录判断 和 访问权限判断
router.beforeEach(function (to, from, next) {
  localStorage.setItem("routerBefore", from.path); //本地存储上级页面
  NProgress.start(); //进度条开始走
  //判断用户缓存的登录信息  如果没有 则没有登录
  if (hasLogin()) {
    if (store.getters.menulist.length <= 0) {
      // 登录结束后 配置系统logo name等 暂时用不到
      store.dispatch('setMenu').then(function (routerconf) {
        if (router.options.routes.length <= 100) {
          router.options.routes = router.options.routes.concat(routerconf);
          router.addRoutes(routerconf);
        }
        var notfoundPage = [{
          path: '*',
          redirect: '/404',
          hidden: true
        }];
        router.options.routes = router.options.routes.concat(notfoundPage);
        router.addRoutes(notfoundPage);
        var navbarActIndex = Lockr.get('navbarActIndex') || 0;
        store.commit('SET_NAVACTIVEINDEX', navbarActIndex);
        if (to.path == '/') {
          store.commit('SET_NAVACTIVEINDEX', store.getters.navActiveIndex);
          router.go(-1);
        } else if (to.meta.next == true) {
          store.commit('SET_NAVACTIVEINDEX', store.getters.navActiveIndex);
          router.go(-1);
        } else {
          router.push({ path: to.path, query: to.query });
        }
      }).catch(function (err) {
        console.log(err);
      });
    } else {
      if (to.path === '/login') {
        //登录状态：去login的用户重定向到首页
        next({
          path: '/login'
        });
        NProgress.done();
      } else {
        //登录 并且不是去login的用户
        next();
      }
    }
  } else {
    // 未登录的用户访问页面 则退出登录跳转login
    if (whiteList.indexOf(to.path) !== -1) {
      next(); //不需要登录的页面可以继续访问
    } else {
      next('/login?redirect=' + to.path); // 否则需要登录的页面 重定向到登录页面 全部重定向到登录页
      NProgress.done(); //进度条结束
    }
  }
});

router.afterEach(function () {
  NProgress.done(); // 结束Progress
});

router.onError(function (error) {
  console.log(error);
  var pattern = /Loading chunk (\d)+ failed/g;
  var isChunkLoadFailed = error.message.match(pattern);
  var targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});